module.exports = {

    data() {
        return {
            marker: null,
            autocomplete: null,
            addressParts: {
                street_number: {
                    key: 'short_name',
                    to: 'address',
                    join: ''
                },
                route: {
                    key: 'long_name',
                    to: 'address',
                    join: ' '
                },
                locality: {
                    key: 'long_name',
                    to: 'city',
                    join: ''
                },
                administrative_area_level_1: {
                    key: 'short_name',
                    to: 'state_id',
                    join: ''
                },
                administrative_area_level_2: {
                    key: 'short_name',
                    to: 'county_id',
                    join: ''
                },
                country: {
                    key: 'short_name',
                    to: 'country',
                    join: ''
                },
                postal_code: {
                    key: 'short_name',
                    to: 'zip',
                    join: ''
                },
                postal_code_suffix: {
                    key: 'short_name',
                    to: 'zip',
                    join: '-'
                }
            }
        }
    },

    mounted() {
        App.bus.$on('google-maps-ready', this.createAutocompleteAddress)
    },

    methods: {

        createAutocompleteAddress() {
            var input = document.getElementById('autocomplete-address');
            this.autocomplete = new google.maps.places.Autocomplete(input);
            this.autocomplete.bindTo('bounds', this.map);

            this.autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);
            this.autocomplete.addListener('place_changed', () => {

                var place = this.autocomplete.getPlace();

                this.setAddressFromPlace(place)

                if (!place.geometry) {
                    Toast.error("No details available for input: '" + place.name + "'");
                    return;
                }

                this.map.setCenter(place.geometry.location);
                this.map.setZoom(13);
                this.createMarker(place.geometry.location);
            });
        },

        setAddressFromPlace(place){
            // Call this method from parent.
        },

        createMarker(location) {
            if(this.marker){
                this.marker.setMap(null);
            }
            this.marker = new google.maps.Marker({
                map: this.map,
                anchorPoint: new google.maps.Point(0, -29)
            });
            this.marker.setPosition(location);
            this.marker.setVisible(true);
        },

        initAddress(address) {
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({'address': address}, (results, status) => {
                if (status === 'OK') {
                    this.map.setCenter(results[0].geometry.location);
                    this.createMarker(results[0].geometry.location)
                } else {
                    console.log('The addreess can not be loaded in the map, please type your address again.');
                }
            });
        }
    }
}
